// Common countries list for dropdown
// Using country names in English to match DDI data
export const COMMON_COUNTRIES = [
    { code: 'BR', name: 'Brazil' },
    { code: 'US', name: 'United States' },
    { code: 'MX', name: 'Mexico' },
    { code: 'AR', name: 'Argentina' },
    { code: 'CL', name: 'Chile' },
    { code: 'CO', name: 'Colombia' },
    { code: 'PE', name: 'Peru' },
    { code: 'ES', name: 'Spain' },
    { code: 'FR', name: 'France' },
    { code: 'IT', name: 'Italy' },
    { code: 'PT', name: 'Portugal' },
    { code: 'GB', name: 'United Kingdom' },
    { code: 'DE', name: 'Germany' },
    { code: 'CA', name: 'Canada' },
    { code: 'AU', name: 'Australia' },
] as const;

export type CommonCountry = typeof COMMON_COUNTRIES[number];
